import React from 'react';
import Utils from '../utils/utils';

const BackLinkHeader = ({ alt, href, title, ...props }) => {
  return (
    <header className="go-back">
      <a className="arrow-back-button" href={href}><img src={require('../../img/arrow_left.svg')} alt={alt} /></a>
      <h1>{title}</h1>
      <button className="vst-href-text-button print-link" onClick={Utils.printReceipt}>{i18n.t('transactions.print-receipt')}</button>
    </header>
  );
}

export default BackLinkHeader;


/** WEBPACK FOOTER **
 ** ./src/js/components/back-link-header.jsx
 **/